<template>
  <b-container>
    <b-alert ref="alert-container" :show="showAlert" class="alert-container">
      <div class="content__alert">
        <b-col class="d-flex m-0 p-0">
          <b-img
            ref="icon-alert"
            class="icon-alert"
            :src="require('@/assets/icon-alert/icon-circle-exclamation.svg')"
          />

          <b-col class="pr-0 text__alert">
            <p ref="text__alert-description" class="mb-0 text-danger font-weight-bold">
              You have recently requested to change your email address.
            </p>
            <span ref="text__alert-confirm" class="text-danger">
              To complete this update, check your email for a confirmation link at
              <span ref="text__alert-email">{{ email }}.</span>
            </span>
          </b-col>
        </b-col>
        <b-col class="m-0 p-0 button-alert">
          <b-button
            ref="button__alert-resend"
            variant="link"
            class="text-danger button__alert-resend"
            @click="viewPageEmailVerify"
          >
            Resend Verification
          </b-button>
        </b-col>
      </div>
    </b-alert>
  </b-container>
</template>

<script>
import ChangeRequest from '@/models/ChangeRequest';

export default {
  props: {
    userId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showAlert: false,
      email: '',
      requestId: null
    };
  },
  mounted() {
    this.onFetch();
  },
  methods: {
    async onFetch() {
      try {
        const params = {
          _sort: 'request_date:desc',
          'change_type.change_type_name': 'ProfileEmailUpdate',
          status: 'Pending',
          user: this.userId
        };

        const {
          response: { data }
        } = await ChangeRequest.api().getChangeRequest(params);

        if (data && data.length) {
          this.requestId = data[0].id;
          this.showAlert = true;
          this.email = data[0].request_data.newEmail;
        }
      } catch (error) {
        console.error(error);
      }
    },

    viewPageEmailVerify() {
      const route = this.$router.resolve({
        name: 'resend-verify-email',
        query: { requestId: this.requestId }
      });
      window.open(route.href, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.content__alert {
  display: grid;
  grid-template-columns: 6fr 2fr;
  gap: 20px;
}

.alert-container {
  background-color: #fde4d5;
  border: 1px solid #fcd9c4;
  margin: 0 24px;
}

.icon-alert {
  width: 1.5rem;
}

.text__alert {
  font-size: 15.2px;
}

.button-alert {
  display: flex;
  justify-content: end;
}

.button__alert-resend {
  padding: 0 !important;
  margin: 0 !important;
  text-decoration: underline;
}

@media screen and (max-width: 767px) {
  .content__alert {
    grid-template-columns: 1fr;
  }

  .button-alert {
    justify-content: start;
  }
}
</style>
